'use client';

import { useAwsRum } from './clientSideMonitoring';

// This is executed in client-side render to initialize monitoring as early as possible.
export function InitClientSideMonitoring() {
  const _rum = useAwsRum();
  return null;
}
